<template>
    <v-dialog
        :value="open"
        max-width="720"
        :fullscreen="$viewport.width < 450"
        persistent
    >
        <v-card color="#061422">
            <v-card-title>
                <span class="title-text">
                    {{ title }}
                </span>
                <v-spacer />
                <v-btn icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <div class="body-text">
                    <p v-for="(line, idx) in bodyLines" :key="idx">
                        {{ line }}
                    </p>
                </div>

                <div class="links">
                    <a
                        class="link"
                        :href="links.instagram"
                        target="_blank"
                        rel="noopener noreferrer"
                    >Instagram</a>
                    <a
                        class="link"
                        :href="links.facebook"
                        target="_blank"
                        rel="noopener noreferrer"
                    >Facebook</a>
                    <a
                        class="link"
                        :href="links.tiktok"
                        target="_blank"
                        rel="noopener noreferrer"
                    >TikTok</a>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'RateLimitDialog',
    computed: {
        ...mapState({
            open: (state) => state.rate_limitStore?.open,
            tier: (state) => state.rate_limitStore?.tier,
        }),
        links() {
            return {
                instagram: 'https://instagram.com/jolicoeur.mtl',
                facebook: 'https://www.facebook.com/jolicoeur.mtl/',
                tiktok: 'https://www.tiktok.com/@jolicoeur.mtl',
            };
        },
        title() {
            return this.tier === 'vip' ? 'Limite atteinte' : 'Limite atteinte';
        },
        bodyLines() {
            if (this.tier === 'vip') {
                return [
                    "Wow vous aimez vraiment Cartomtl! Écrivez-moi un message privé, j'aimerais vous parler.",
                ];
            }
            return [
                'Vous avez déjà atteint la limite de 5 parties par heure!',
                'Faire fonctionner ce jeu me coûte de l’argent (environ 0,10 $ par partie). Je dois donc malheureusement mettre une limite.',
                'Si vous voulez vraiment continuer à jouer, ajoutez-moi et écrivez-moi sur Instagram, Facebook ou TikTok, et je vous donnerai un accès secret à plus de parties.',
            ];
        },
    },
    methods: {
        close() {
            this.$store.dispatch('rate_limitStore/hide');
        },
    },
};
</script>

<style scoped>
.title-text {
    color: #ddd;
    font-size: 16px;
    font-weight: 600;
    opacity: 0.95;
}

.body-text {
    color: #bbb;
    white-space: pre-line;
}

.body-text p {
    margin: 0 0 0.75rem;
}

.links {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    margin-top: 0.75rem;
}

.link {
    color: #fff;
    font-weight: 800;
    text-decoration: underline;
    text-underline-offset: 4px;
}
</style>
